export class TipoViaVariacion {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public nombre: string | undefined;
    public tipoVia: string | undefined;
}